export const ErrorTest = () => {
  throw 'This is the error';
};
